var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconLaunchbarBlast = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.394 19.505 11.885 30.28c-.144.62.667.99 1.041.475l12.07-16.618a.584.584 0 0 0-.472-.927h-6.35a.584.584 0 0 1-.568-.716L20.115 1.72c.144-.62-.667-.99-1.041-.475L7.004 17.862a.584.584 0 0 0 .472.927h6.35c.376 0 .654.35.568.716",
  className: "icon_launchbar_blast_svg__st0"
})));
export default SvgIconLaunchbarBlast;